import { type ReactNode } from 'react';
import { emitSuccessToast } from '@adv-frontend/toast';
import { successQueue } from './queues';

export const showSuccess = (
    content: ReactNode,
    options?: {
        caption: string;
    }
) => {
    // eslint-disable-next-line no-restricted-syntax -- Только здесь и можно использовать emitSuccessToast
    const id = emitSuccessToast(content, {
        ...(options ?? {}),
        hasClose: true,
    });

    successQueue(id);

    return id;
};
